import {
  UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,
  ADGLARE_CONTENT_FETCHED,
} from '../constants/actionTypes.js'

const initialState = {
  // Property ids the server reports as saved for the just-authenticated user.
  // SRP results are rendered from useListingsSearch (not this slice); searchPanel
  // reads these to seed its saved-state on login, since the search hook does not
  // refetch on auth change.
  currentlySavedPropertyIds: [],
  adglareContent: null,
  adglareFetchAttempted: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER: {
      return {
        ...state,
        currentlySavedPropertyIds: action.currently_saved_property_ids || [],
      }
    }

    case ADGLARE_CONTENT_FETCHED: {
      return Object.assign({}, state, {
        adglareContent: action.value,
        adglareFetchAttempted: true,
      })
    }

    default:
      return state
  }
}

export default reducer
export { initialState }
